import React from "react";
// import MailApp from "../pages/apps/mail";


import Page from "@jumbo/shared/Page";
import QC_FileUpload from "./QC_FileUpload";
import QC_Archives from "./QC_Archives";


import TenantAdminRoute from "../../routes/TenantAdminRoute";

const QC_routes = [
   
    {
        path: ["/qc","/qc/file-upload"],
        element: <TenantAdminRoute element ={<Page component={QC_FileUpload}/>} />
    },
    {
        path: "/qc/archives",
        element: <TenantAdminRoute element ={<Page component={QC_Archives}/>} />
    }
    
];

export default QC_routes;
